import { FC, JSX } from "react";
import { Box } from "@radix-ui/themes";
import { AuthImageProps } from "./AuthImage.types";

const AuthImage: FC<AuthImageProps> = ({ image }): JSX.Element => {
  return (
    <Box position="relative" display={{ initial: "none", lg: "block" }}>
      <svg
        id="authImage"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 553.97 797.08"
        width="100%"
        height="100%"
      >
        <defs>
          <pattern
            id="img1"
            patternUnits="userSpaceOnUse"
            width="100%"
            height="100%"
          >
            <image
              href={image}
              x="0"
              y="0"
              width="100%"
              height="100%"
              preserveAspectRatio="xMidYMid slice"
            />
          </pattern>
        </defs>
        <g id="authImage-group">
          <path
            d="M0,55.75s1.37,632.12,1.49,686.79c.12,54.67,54.78,54.55,54.78,54.55,0,0,202.15-.44,256.81-.56,54.67-.12,54.96-27.81,54.92-44.79-.04-16.97-1.07-39.45,35.01-39.53,26.07-.06,96.41-.21,96.41-.21,0,0,54.67-.33,54.55-55-.32-149.87-1.21-557.93-1.31-602.45C552.54-.11,499.88,0,499.88,0,499.88,0,109.21.85,54.55.97-.12,1.08,0,55.75,0,55.75Z"
            fill="url(#img1)"
          />
        </g>
      </svg>
    </Box>
  );
};

export default AuthImage;
